module.exports = __webpack_public_path__ + "static/media/exp_anchorage_2.c80963ab.svg";